import { useQuery } from '@apollo/client';
import { useState, useEffect } from 'react';
import { GET_BUSINESS_BY_URL } from '../../../../graphql/queries';
import BookingTypeList from '../../../../components/business/calendar/month/bookingTypeList';
import BusinessBookingTypeList from '../../../../components/business/bookingType/businessBookingTypeList';

const EmbededPage = ({ businessUrl, primaryColor }) => {
    const [business, setBusiness] = useState(null);
    const { loading: loadingBusiness, error: errorBusiness, data: dataBusiness } = useQuery(GET_BUSINESS_BY_URL, {
        variables: { businessUrl: businessUrl },
    });

    useEffect(() => {
        if (dataBusiness && dataBusiness.businessByUrl) {
            setBusiness({ ...dataBusiness.businessByUrl, businessBasic: dataBusiness.businessByUrl });
        }
    }, [dataBusiness]);

    if (loadingBusiness) {
        return <div>Loading...</div>;
    }

    if (errorBusiness) {
        return <div>Error loading business details.</div>;
    }

    return (
        business && (
            <BusinessBookingTypeList
                business={business}
                primaryColor={primaryColor || '#000000'}
                embeded={true}
            />
        )
    );
};

export default EmbededPage;
